module.exports = __webpack_public_path__ + "img/1.954d7d9c.jpg";